module.exports = __webpack_public_path__ + "37e353b3c9d698d9fdbac4ae84edf51b.svg";